import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { TutorialDto } from "../../../api/psc";
import { DialogContext } from "../../../contexts/DialogContext";
import TutorialDialog from "../dialogs/TutorialDialog";

export default function TutorialItem(props: { item: TutorialDto }) {
    const [imageLoaded, setImageLoaded] = useState(false);

    const { openDialog } = useContext(DialogContext);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const openVideoDialog = () => {
        openDialog(<TutorialDialog item={props.item} />);
    };

    return (
        <Box height="100%">
            <Card sx={{ height: "100%" }}>
                <Stack sx={{ height: "100%" }}>
                    <CardMedia
                        component="img"
                        style={{ aspectRatio: 16 / 9 }}
                        onLoad={handleImageLoad}
                        className={imageLoaded ? "img-fade-in" : ""}
                        image={props.item.thumbnailUri}
                    />
                    <CardContent sx={{ flex: 1 }}>
                        <Stack sx={{ height: "100%" }}>
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                sx={{ mb: 1 }}
                            >
                                <Typography color="primary">
                                    {props.item.title}
                                </Typography>
                                <Chip
                                    label={props.item.category}
                                    size="small"
                                />
                            </Stack>

                            <Typography color="text.secondary">
                                {props.item.description}
                            </Typography>

                            <span style={{ flex: 1 }}></span>

                            <Button
                                fullWidth
                                sx={{ mt: 2 }}
                                onClick={openVideoDialog}
                                variant="contained"
                            >
                                مشاهده ویدیو
                            </Button>
                        </Stack>
                    </CardContent>
                </Stack>
            </Card>
        </Box>
    );
}
